<template>
    <v-card class="stat-card">
        <v-card-text>
            <div class="card-heading">
                <div class="card-title">Виды абонементов за</div>
                <v-select
                        v-model="period"
                        :items="periods"
                        return-object
                        item-text="name"
                        @change="onPeriodChange"
                        outlined
                        dense
                        hide-details
                />
                <router-link :to="{name: 'cards.list', query: {period: period.value, page: 1}}" class="card-value">
                    {{ total }}
                </router-link>
            </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
            <menu-stats-doughnut-chart v-show="chartData && chartData.datasets[0].data.length"
                                       :chart-data="chartData"
                                       :height="300"
                                       :width="300"
                                       class="card-chart"
            />
            <div v-if="!chartData || !chartData.datasets[0].data.length" class="card-chart-placeholder">
                Нет данных
            </div>
        </v-card-text>
        <v-card-text v-if="stats.length" class="pa-0">
            <v-divider></v-divider>
            <div class="clients-table">
                <v-data-table
                        :headers="headers"
                        :items="stats"
                        disable-pagination
                        hide-default-footer
                >
                    <template v-slot:item.name="{item}">
                        <div class="td-cardType">
                            <div :style="{backgroundColor: item.color}" class="box-color"></div>
                            {{ item.name }}
                        </div>
                    </template>
                    <template v-slot:item.percent="{item}">
                        {{ total ? (item.count / total * 100).toFixed(2) : 0 }}%
                    </template>
                </v-data-table>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import MenuStatsDoughnutChart from "./StatCardsByTypeDoughnutChart";
    import statisticApi from '../api/statistic.api';
    import randomColor from 'randomcolor';

    const colors = [
        '#3366cc',
        '#dc3912',
        '#ff9900',
        '#109618',
        '#990099',
        '#0099c6',
        '#dd4477',
        '#66aa00',
        '#b82e2e',
        '#316395',
        '#994499',
        '#22aa99',
        '#aaaa11',
        '#6633cc',
        '#e67300',
        '#8b0707',
        '#651067',
        '#329262',
        '#5574a6',
        '#3b3eac',
        '#b77322',
        '#16d620',
        '#b91383',
        '#f4359e',
        '#9c5935',
        '#a9c413',
        '#2a778d',
        '#668d1c',
        '#bea413',
        '#0c5922',
        '#743411', ...randomColor({count: 50, luminosity: 'bright', hue: 'random'})];

    export default {
        name      : "StatCardsByType",
        components: {MenuStatsDoughnutChart},
        data() {
            return {
                chartData: null,

                period : {
                    name : 'Сегодня',
                    value: 'today'
                },
                periods: [
                    {
                        name : 'Все время',
                        value: 'all'
                    },
                    {
                        name : 'Последние 30 дней',
                        value: 'last_30_days'
                    },
                    {
                        name : 'Последние 7 дней',
                        value: 'last_7_days'
                    },
                    {
                        name : 'Вчера',
                        value: 'yesterday'
                    },
                    {
                        name : 'Сегодня',
                        value: 'today'
                    },
                ],
                headers: [
                    {text: 'Вид абонемента', value: 'name', sortable: false},
                    {text: 'Количество', value: 'count'},
                    {text: 'Процент', value: 'percent'},
                ],
                stats  : [],
            }
        },
        computed  : {
            total() {
                let total = 0;
                this.stats.forEach((item) => {
                    total += item.count;
                });
                return total;
            }
        },
        created() {
            this.fetchStat();
        },
        methods   : {
            onPeriodChange() {
                this.fetchStat();
            },
            fetchStat() {
                this.$store.commit('setLoading', true);

                statisticApi.cardsByType({period: this.period ? this.period.value : null}).then(({data}) => {
                    this.stats = data;

                    this.stats.forEach((item, index) => {
                        this.$set(item, 'color', colors[index]);
                    });

                    this.fillChartData(data);
                }).catch(() => {
                    this.$toast.error('Что-то пошло не так. Пожалуйста, повторите попытку позже');
                }).finally(() => {
                    this.$store.commit('setLoading', false);
                });
            },
            fillChartData(stats) {
                const chartData = {
                    labels  : [],
                    datasets: [
                        {
                            label          : 'Виды абонементов',
                            data           : [],
                            backgroundColor: colors,
                        }
                    ],
                };

                stats.forEach((stat) => {
                    chartData.labels.push(stat.name);
                    chartData.datasets[0].data.push(stat.count);
                });

                this.chartData = chartData;
            }
        }
    }
</script>

<style scoped>

</style>
